import { ballArr, count, singleDouble, singleDoubleCnname, smallBig, continuity, continuityCnname, smallBigCnname, dragonTiger, fishCnname } from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';

let lostChildren = index => {
  var arr = [];
  for (let i = 0; i < 10; i++) {
    var obj = {};
    obj.title = `${i}`;
    obj.align = 'center';
    // obj.width = '34';
    obj.className = `lost_table_children_${i}`;
    obj.render = (h, row) => {
      var name = `ball${index}`;
      var key = row.row.key;
      var n = row.row.lost.ballJson[name].nums[i];
      // console.log(n[key], n, 'asdfasdf');
      if (key != 'averageOmit') {
        return <span>{n[key] ? n[key] : 0}</span>;
      }
    };
    arr.push(obj);
  }
  return arr;
};
let lhLostChildren = index => {
  var arr = [];
  var shape = ['龙', '虎', '和'];
  var str = ['l', 'h', 'he'];
  for (let i = 0; i < shape.length; i++) {
    var obj = {};
    obj.title = `${shape[i]}`;
    obj.align = 'center';
    // obj.width = '35';
    obj.className = `join_table_children`;
    obj.render = (h, row) => {
      var name = str[i];
      var key = row.row.key;
      var n = row.row.lost.lhJson[name][key];
      return <span class="table_join">{n}</span>;
    };
    arr.push(obj);
  }
  return arr;
};

let treeChildren = (index, data, ball) => {
  var arr = [];
  if (data) {
    for (let i = 0; i < 10; i++) {
      var obj = {};
      obj.title = `${i}`;
      obj.align = 'center';
      // obj.width = '36';
      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {
        var name = `ball${ball}`;
        // console.log(name, 'name');
        var n = row.row.ball_json[name].nums[i];
        var num = data[0].ball_json[name].nums[i];
        if (n == 0) {
          return <span class="red">{data[row.index].ballList[index]}</span>;
        } else if (num > row.index) {
          return <span class="divide_lost_info lost_info">{n}</span>;
        } else {
          return <span class="lost_info">{n}</span>;
        }
        // } else {
        //   return <span class="lost_info">{row.row.ball_json[name].nums[i]}</span>;
        // }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let joinChildren = data => {
  var arr = [];
  var shape = ['龙', '虎', '和'];
  var str = ['l', 'h', 'he'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '35';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var n = row.row.lh_json[str[i]];
        var num = data[0].lh_json[str[i]];
        if (n == 0) {
          return <span class="table_join_red">{shape[i]}</span>;
        } else if (num > row.index) {
          return <span class="divide_lost_info lost_info">{n}</span>;
        } else {
          return <span class="lost_info">{n}</span>;
        }
        // } else {
        //   return <span class="table_join">{row.row.lh_json[str[i]]}</span>;
        // }
      };
      arr.push(obj);
    }
    return arr;
  }
};

const ssc = data => {
  let list = Vue => {
    let arr = [
      {
        title: '期数',
        align: 'center',
        key: 'issue_id',
        className: `table_issueId`,
        width: 170
      },
      {
        title: '开奖号码',
        align: 'center',
        width: 140,
        render: (h, { row }) => <span class="issue_result">{row.balls.split(',').join('')}</span>
      }
      // {
      //   title: '第一球号码走势',
      //   align: 'center',
      //   width: 300,
      //   className: `table_info_column_1`,
      //   children: treeChildren(0, data)
      // },
      // {
      //   title: '第五球号码走势',
      //   align: 'center',
      //   width: 300,
      //   className: `table_info_column_5`,
      //   children: treeChildren(1, data)
      // },
      // {
      //   title: '龙虎',
      //   align: 'center',
      //   className: `table_issueId`,
      //   children: joinChildren(data),
      //   width: 150
      // }
    ];
    var a = [1, 5];
    for (let i = 0; i < data[0].ballList.length; i++) {
      let obj = {};
      let e = a[i];
      obj.title = `第${e}球号码走势`;
      obj.align = 'center';
      // obj.width = '300';
      obj.key = 'resultStr';
      obj.className = `table_info_column_${i}`;
      obj.children = treeChildren(i, data, a[i]);
      arr.push(obj);
    }
    arr.push({
      title: '龙虎',
      align: 'center',
      className: `table_issueId`,
      children: joinChildren(data)
      // width: 150
    });

    return arr;
  };

  let lostList = Vue => {
    let arr = [
      {
        title: '数据统计',
        align: 'center',
        key: 'name',
        className: `table_issueId`,
        width: 310
      }
    ];
    var a = ['一', '五'];
    var indexs = [1, 5];
    for (let i = 0; i < a.length; i++) {
      let obj = {};
      let e = a[i];
      obj.title = `第${e}球`;
      obj.align = 'center';
      // obj.width = '300';
      obj.className = `table_info_column_${i}`;
      obj.children = lostChildren(indexs[i]);
      arr.push(obj);
    }
    arr.push({
      title: '龙虎',
      align: 'center',
      className: `table_issueId`,
      children: lhLostChildren(data)
    });
    return arr;
  };
  let describe =
    '<p>龙：开出之号码第一球大于第五球，为龙。如，第一球开出4第五球开出2。</p>' +
    '<p>虎：开出之号码第一球小于第五球，为虎。如，第一球开出7第五球开出9</p>' +
    '<p>和：开出之号码第一球等于第五球，为和；如开出结果：2***2、9***9等则和局</p>' +
    '<p>遗漏期数：自上期开出到本期间隔的期数。</p>' +
    '<p>出现次数：统计周期内，某个号码的累计出现次数。</p>' +
    // '<p>平均遗漏：统计期数内遗漏的平均值（计算公式：平均遗漏＝统计期内的总遗漏数/(出现次数+1)）' +
    '<p>最大遗漏：是指统计周期内所有遗漏值的最大值。</p>' +
    '<p>组最大连出：是指统计周期内所有连出值的最大值。</p>';
  return { list, lostList, describe };
};

export default ssc;



// WEBPACK FOOTER //
// ./src/pages/Trend/Longhuzoushi/columns/ssc.js